import React, { useState } from 'react'
import './test.css';


function Text() {
     
    const [message, setMessage] = useState("Lengo letu ni moja tu, kuhakikisha wateja wetu wanafurahi kwa kuona wamepata huduma bora tena zaid ya walichokua wanakitegemea, Pia tuna ndoto za kuipeleka mbele nchi yetu katika teknolojia");

    const updateContent = () => {
        setMessage("Lengo letu ni moja tu, kuhakikisha wateja wetu wanafurahi kwa kuona wamepata huduma bora tena zaid ya walichokua wanakitegemea, Pia tuna ndoto za kuipeleka mbele nchi yetu katika teknolojia")
    }
    
    const updateContent2 = () => {
        setMessage("Faida utakazozipata ukiwa nasisi ni kwamba hautalipia hosting, website yako itawekwa online bure kabisa, pia tunatoa huduma za marekebisho ya kila mwezi, pia tunatoa huduma kwa wateja masaa 24 bure kabisa")
    }

    const updateContent3 = () => {
        setMessage("Tunakuhakikishia kwamba huduma zetu utazifurahia na utaridhika nazo, na kama hautaridhika basi tutakufanyia marekebisho, Tumekuja kikazi, wateja wetu wote mtafurahi sana hiyo ahadi iko ndani ya uwezo wetu ")
    }


    return (
        <div className="text">
             <div className="missio" >
                       <h3 className="optio" onClick={updateContent} >LENGO LETU</h3>
                       <h3 className="optio" onClick={updateContent2} >FAIDA ZETU</h3>
                        <h3  className="optio" onClick={updateContent3}>TUNAKUHAKIKISHIA</h3>
                     </div>

                      <div className='active'>{message}
                      </div>
                 
            </div>
        
    )
}

export default Text
